import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

const TOP_SHEET_Z_INDEX = 1050;

@observer
class TopSheet extends Component {
    onCloseClick = (e) => {
        e.stopPropagation();
        const { appState } = this.props.stores;
        appState.closeTopSheet();
    }

    render() {
        const { appState } = this.props.stores;
        const {
            showTopSheet,
            topSheetComponent,
            topSheetProps = {},
            topSheetHeight = '25vh',
        } = appState;

        // Render shell at all times so the slide-up animation has content.
        // Component itself is null on first ever open until a caller passes one.
        const Inner = topSheetComponent;

        return (
            <div
                style={`
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: calc(${topSheetHeight} + env(safe-area-inset-top, 0px));
                    z-index: ${TOP_SHEET_Z_INDEX};
                    transform: translateY(${showTopSheet ? '0' : '-100%'});
                    transition: transform 300ms ease;
                    padding-top: env(safe-area-inset-top, 0px);
                    pointer-events: ${showTopSheet ? 'auto' : 'none'};
                `}
                class={`bg-body text-body border-bottom${showTopSheet ? ' shadow' : ''}`}
            >
                <button
                    type='button'
                    class='btn btn-sm btn-link text-body-secondary p-1'
                    onClick={this.onCloseClick}
                    aria-label='Close'
                    title='Close'
                    style='position: absolute; top: calc(6px + env(safe-area-inset-top, 0px)); right: 8px; z-index: 2;'
                >
                    <i class='fa-regular fa-xmark' style='font-size: 1.2rem;' />
                    <span class='visually-hidden'>
                        <Text id='topsheet.close'>Close</Text>
                    </span>
                </button>
                <div style='height: 100%; overflow: hidden;'>
                    {Inner ? <Inner stores={this.props.stores} {...topSheetProps} /> : null}
                </div>
                <div
                    style={`
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: -1px;
                        height: 18px;
                        background: var(--bs-body-bg);
                        border-radius: 10px 10px 0 0;
                        box-shadow: ${showTopSheet ? '0 -8px 18px rgba(0, 0, 0, 0.35)' : 'none'};
                        pointer-events: none;
                        visibility: ${showTopSheet ? 'visible' : 'hidden'};
                    `}
                >
                    <div
                        style='
                            position: absolute;
                            top: 6px;
                            left: 50%;
                            width: 44px;
                            height: 5px;
                            border-radius: 3px;
                            background: var(--bs-secondary);
                            opacity: 0.45;
                            transform: translateX(-50%);
                        '
                    />
                </div>
            </div>
        );
    }
}

export default TopSheet;
